import React, { useEffect, useState } from "react";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Chip from "@material-ui/core/Chip";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import useSettings from "../../hooks/useSettings";
import { toast } from 'react-toastify';
import { makeStyles } from "@material-ui/core/styles";
import { useStyles } from "./OptionsStyles";
import SettingItem from "./SettingItem";
import OptionsTimezoneSection from "./OptionsTimezoneSection";
import useOptionsSettings from "./useOptionsSettings";
import { i18n } from '../../translate/i18n.js';
import api from '../../services/api';
import { DEFAULT_TICKET_CLOSE_MESSAGE } from "../../constants/defaultTicketCloseMessage";
import {
  DEFAULT_USER_RATING_MESSAGE_TEXT,
  DEFAULT_SEND_GREETING_ACCEPTED_MESSAGE_TEXT,
  DEFAULT_TRANSFER_TICKET_MESSAGE_TEXT,
  DEFAULT_SEND_GREETING_ONE_QUEUE_MESSAGE_TEXT
} from "../../constants/defaultMessagingSettings";

//import 'react-toastify/dist/ReactToastify.css';
 

// Componente helper para renderizar configuraciones individuales
export default function Options(props) {
  const { settings, scheduleTypeChanged } = props;
  const classes = useStyles();

 

  const {
    CheckMsgIsGroup,
    SendGreetingAccepted,
    SettingsTransfTicket,
    callAutoMessage,
    callType,
    chatbotType,
    customerMessageLocale,
    greetingOneQueueMessageText,
    handleCallAutoMessage,
    handleCallType,
    handleChangeTimezone,
    handleChangeUserRating,
    handleChatbotType,
    handleCustomerMessageLocale,
    handleGroupType,
    handleInternalSignature,
    handleRemoveTagsOnCloseTicket,
    handleRestoreDefaultMessage,
    handleRestoreDefaultTicketCloseMessage,
    handleScheduleType,
    handleSendGreetingAccepted,
    handleSendGreetingMessageOneQueues,
    handleSendTicketCloseMessage,
    handleSettingsTransfTicket,
    handleValidateWhatsAppNumbers,
    internalSignature,
    loadingCallAutoMessage,
    loadingCallType,
    loadingChatbotType,
    loadingCheckMsgIsGroup,
    loadingCustomerMessageLocale,
    loadingGreetingOneQueueMessageText,
    loadingInternalSignature,
    loadingRemoveTagsOnCloseTicket,
    loadingScheduleType,
    loadingSendGreetingAccepted,
    loadingSendGreetingAcceptedMessageText,
    loadingSendGreetingMessageOneQueues,
    loadingSendTicketCloseMessage,
    loadingSettingsTransfTicket,
    loadingTicketCloseMessageText,
    loadingTimezoneType,
    loadingTimezones,
    loadingTransferTicketMessageText,
    loadingUserRating,
    loadingUserRatingMessageText,
    loadingValidateWhatsAppNumbers,
    persistGreetingOneQueueMessageText,
    persistSendGreetingAcceptedMessageText,
    persistTicketCloseMessageText,
    persistTransferTicketMessageText,
    persistUserRatingMessageText,
    removeTagsOnCloseTicket,
    savedCallAutoMessage,
    savedGreetingOneQueueMessageText,
    savedSendGreetingAcceptedMessageText,
    savedTicketCloseMessageText,
    savedTransferTicketMessageText,
    savedUserRatingMessageText,
    scheduleType,
    sendGreetingAcceptedMessageText,
    sendGreetingMessageOneQueues,
    sendTicketCloseMessage,
    setCallAutoMessage,
    setCallType,
    setChatbotType,
    setCheckMsgIsGroupType,
    setCustomerMessageLocale,
    setGreetingOneQueueMessageText,
    setInternalSignature,
    setLoadingCallAutoMessage,
    setLoadingCallType,
    setLoadingChatbotType,
    setLoadingCheckMsgIsGroup,
    setLoadingCustomerMessageLocale,
    setLoadingGreetingOneQueueMessageText,
    setLoadingInternalSignature,
    setLoadingRemoveTagsOnCloseTicket,
    setLoadingScheduleType,
    setLoadingSendGreetingAccepted,
    setLoadingSendGreetingAcceptedMessageText,
    setLoadingSendGreetingMessageOneQueues,
    setLoadingSendTicketCloseMessage,
    setLoadingSettingsTransfTicket,
    setLoadingTicketCloseMessageText,
    setLoadingTimezoneType,
    setLoadingTimezones,
    setLoadingTransferTicketMessageText,
    setLoadingUserRating,
    setLoadingUserRatingMessageText,
    setLoadingValidateWhatsAppNumbers,
    setRemoveTagsOnCloseTicket,
    setSavedCallAutoMessage,
    setSavedGreetingOneQueueMessageText,
    setSavedSendGreetingAcceptedMessageText,
    setSavedTicketCloseMessageText,
    setSavedTransferTicketMessageText,
    setSavedUserRatingMessageText,
    setScheduleType,
    setSendGreetingAccepted,
    setSendGreetingAcceptedMessageText,
    setSendGreetingMessageOneQueues,
    setSendTicketCloseMessage,
    setSettingsTransfTicket,
    setTicketCloseMessageText,
    setTimezoneType,
    setTimezones,
    setTransferTicketMessageText,
    setUserRating,
    setUserRatingMessageText,
    setValidateWhatsAppNumbers,
    ticketCloseMessageText,
    timezoneType,
    timezones,
    transferTicketMessageText,
    userRating,
    userRatingMessageText,
    validateWhatsAppNumbers,
    teamsEnabled,
    loadingTeamsEnabled,
    handleChangeTeamsEnabled,
  } = useOptionsSettings(props);

  return (
    <Box className={classes.container}>
      {/* CONFIGURACIONES PRINCIPALES */}
      <Card className={classes.sectionCard}>
        <Box className={classes.sectionHeader}>
          <Typography className={classes.sectionTitle}>
            <span role="img" aria-label={i18n.t("settings.options.ariaSectionMain")}>⚙️</span> {i18n.t("settings.options.mainSettings")}
          </Typography>
        </Box>
        <CardContent className={classes.sectionContent}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <SettingItem
                label={i18n.t("settings.options.userRating")}
                description={i18n.t("settings.options.userRatingDesc")}
                value={userRating}
                onChange={(e) => handleChangeUserRating(e.target.value)}
                options={[
                  { value: "disabled", label: i18n.t("settings.states.disabled") },
                  { value: "enabled", label: i18n.t("settings.states.enabled") }
                ]}
                loading={loadingUserRating}
                classes={classes}
              />
            </Grid>

            {userRating === "enabled" && (
              <Grid item xs={12}>
                <Box className={classes.settingItem}>
                  <Typography className={classes.settingLabel}>
                    {i18n.t("settings.options.userRatingMessageText")}
                  </Typography>
                  <Typography className={classes.settingDescription}>
                    {i18n.t("settings.options.userRatingMessageTextDesc")}
                  </Typography>
                  <Box display="flex" flexDirection="column" gap={2} mt={2}>
                    <TextField
                      multiline
                      rows={4}
                      fullWidth
                      variant="outlined"
                      value={userRatingMessageText}
                      onChange={(e) => {
                        const v = e.target.value;
                        if (v.length <= 500) setUserRatingMessageText(v);
                      }}
                      onBlur={(e) => {
                        const v = e.target.value;
                        const toSave =
                          String(v || "").trim() || DEFAULT_USER_RATING_MESSAGE_TEXT;
                        if (savedUserRatingMessageText !== toSave) {
                          persistUserRatingMessageText(v);
                        }
                      }}
                      placeholder={i18n.t("settings.options.userRatingMessageTextPlaceholder")}
                      helperText={`${userRatingMessageText.length}/500 ${i18n.t("settings.options.characters")}`}
                      disabled={loadingUserRatingMessageText || loadingUserRating}
                      InputProps={{ className: classes.textFieldInput }}
                    />
                    <Box display="flex" gap={2} alignItems="center">
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => persistUserRatingMessageText(DEFAULT_USER_RATING_MESSAGE_TEXT)}
                        disabled={loadingUserRatingMessageText || loadingUserRating}
                        size="small"
                      >
                        {i18n.t("settings.options.restoreDefault")}
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            )}

            <Grid item xs={12} sm={6} md={4}>
              <SettingItem
                label={i18n.t("settings.options.scheduleType")}
                description={i18n.t("settings.options.scheduleTypeDesc")}
                value={scheduleType}
                onChange={(e) => handleScheduleType(e.target.value)}
                options={[
                  { value: "disabled", label: i18n.t("settings.states.disabled") },
                  { value: "queue", label: i18n.t("settings.states.queue") },
                  { value: "company", label: i18n.t("settings.states.company") }
                ]}
                loading={loadingScheduleType}
                classes={classes}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <SettingItem
                label={i18n.t("settings.options.ignoreGroupMessages")}
                description={i18n.t("settings.options.ignoreGroupMessagesDesc")}
                value={CheckMsgIsGroup}
                onChange={(e) => handleGroupType(e.target.value)}
                options={[
                  { value: "disabled", label: i18n.t("settings.states.deactivated") },
                  { value: "enabled", label: i18n.t("settings.states.activated") }
                ]}
                loading={loadingCheckMsgIsGroup}
                classes={classes}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <SettingItem
                label={i18n.t("settings.options.sendCallAutoMessage")}
                description={i18n.t("settings.options.sendCallAutoMessageDesc")}
                value={callType}
                onChange={(e) => handleCallType(e.target.value)}
                options={[
                  { value: "disabled", label: i18n.t("settings.states.enabled") },
                  { value: "enabled", label: i18n.t("settings.states.disabled") }
                ]}
                loading={loadingCallType}
                classes={classes}
                invertStatus={true}  // ✅ Invertir lógica: "disabled" = Habilitado, "enabled" = Deshabilitado
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <SettingItem
                label={i18n.t("settings.options.chatbotType")}
                description={i18n.t("settings.options.chatbotTypeDesc")}
                value={chatbotType}
                onChange={(e) => handleChatbotType(e.target.value)}
                options={[
                  { value: "text", label: i18n.t("settings.states.text") }
                ]}
                loading={loadingChatbotType}
                classes={classes}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <SettingItem
                label={i18n.t("settings.options.removeTagsOnCloseTicket")}
                description={i18n.t("settings.options.removeTagsOnCloseTicketDesc")}
                value={removeTagsOnCloseTicket}
                onChange={(e) => handleRemoveTagsOnCloseTicket(e.target.value)}
                options={[
                  { value: "disabled", label: i18n.t("settings.states.disabled") },
                  { value: "enabled", label: i18n.t("settings.states.enabled") }
                ]}
                loading={loadingRemoveTagsOnCloseTicket}
                classes={classes}
              />
            </Grid>

            {/* Modo equipos (doc 0380 D7). Al encenderlo aparece la página de
                Subagrupaciones y los supervisores pasan a ver además las colas
                de su equipo. Nunca recorta lo que alguien ya veía. */}
            <Grid item xs={12} sm={6} md={4}>
              <SettingItem
                label={i18n.t("settings.options.teamsEnabled")}
                description={i18n.t("settings.options.teamsEnabledDesc")}
                value={teamsEnabled}
                onChange={(e) => handleChangeTeamsEnabled(e.target.value)}
                options={[
                  { value: "disabled", label: i18n.t("settings.states.disabled") },
                  { value: "enabled", label: i18n.t("settings.states.enabled") }
                ]}
                loading={loadingTeamsEnabled}
                classes={classes}
              />
            </Grid>
          </Grid>

          {/* Campo para editar mensaje automático - Solo visible si está Habilitado (disabled) */}
          {callType === "disabled" && (
            <Box className={classes.settingItem} style={{ marginTop: 16 }}>
              <Typography className={classes.settingLabel}>
                {i18n.t("settings.options.callAutoMessage")}
              </Typography>
              <Typography className={classes.settingDescription}>
                {i18n.t("settings.options.callAutoMessageDesc")}
              </Typography>
              <Box display="flex" flexDirection="column" gap={2} mt={2}>
                <TextField
                  multiline
                  rows={4}
                  fullWidth
                  variant="outlined"
                  value={callAutoMessage}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (newValue.length <= 500) {
                      setCallAutoMessage(newValue);
                    }
                  }}
                  onBlur={(e) => {
                    const newValue = e.target.value;
                    // ✅ Comparar contra el valor GUARDADO en BD, no contra el estado actual
                    if (savedCallAutoMessage !== newValue) {
                      handleCallAutoMessage(newValue);
                    }
                  }}
                  placeholder={i18n.t("settings.options.callAutoMessagePlaceholder")}
                  helperText={`${callAutoMessage.length}/500 ${i18n.t("settings.options.characters")}`}
                  disabled={loadingCallAutoMessage}
                  InputProps={{
                    className: classes.textFieldInput
                  }}
                  InputLabelProps={{
                    className: classes.textFieldLabel
                  }}
                />
                <Box display="flex" gap={2} alignItems="center">
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleRestoreDefaultMessage}
                    disabled={loadingCallAutoMessage}
                    size="small"
                  >
                    {i18n.t("settings.options.restoreDefault")}
                  </Button>
                  {loadingCallAutoMessage && (
                    <Typography variant="caption" color="textSecondary">
                      {i18n.t("settings.states.updating")}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Box>
          )}
        </CardContent>
      </Card>

      {/* CONFIGURACIONES DE MENSAJERÍA */}
      <Card className={classes.sectionCard}>
        <Box className={classes.sectionHeader}>
          <Typography className={classes.sectionTitle}>
            <span role="img" aria-label={i18n.t("settings.options.ariaSectionMessaging")}>💬</span> {i18n.t("settings.options.messagingSettings")}
          </Typography>
        </Box>
        <CardContent className={classes.sectionContent}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box className={classes.settingItem}>
                <Typography className={classes.settingLabel}>
                  {i18n.t("settings.options.customerMessageLocale")}
                </Typography>
                <Typography className={classes.settingDescription}>
                  {i18n.t("settings.options.customerMessageLocaleDesc")}
                </Typography>
                <FormControl
                  className={classes.formControl}
                  variant="outlined"
                  margin="dense"
                  style={{ maxWidth: 360 }}
                >
                  <InputLabel id="customer-message-locale-label">
                    {i18n.t("settings.options.customerMessageLocale")}
                  </InputLabel>
                  <Select
                    labelId="customer-message-locale-label"
                    value={customerMessageLocale}
                    onChange={(e) => handleCustomerMessageLocale(e.target.value)}
                    label={i18n.t("settings.options.customerMessageLocale")}
                    disabled={loadingCustomerMessageLocale}
                  >
                    <MenuItem value="es">{i18n.t("settings.options.localeEs")}</MenuItem>
                    <MenuItem value="en">{i18n.t("settings.options.localeEn")}</MenuItem>
                    <MenuItem value="pt">{i18n.t("settings.options.localePt")}</MenuItem>
                  </Select>
                  {loadingCustomerMessageLocale && (
                    <FormHelperText className={classes.loadingText}>
                      {i18n.t("settings.states.updating")}
                    </FormHelperText>
                  )}
                </FormControl>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <SettingItem
                label={i18n.t("settings.options.sendGreetingAccepted")}
                description={i18n.t("settings.options.sendGreetingAcceptedDesc")}
                value={SendGreetingAccepted}
                onChange={(e) => handleSendGreetingAccepted(e.target.value)}
                options={[
                  { value: "disabled", label: i18n.t("settings.states.disabled") },
                  { value: "enabled", label: i18n.t("settings.states.enabled") }
                ]}
                loading={loadingSendGreetingAccepted}
                classes={classes}
              />
            </Grid>

            {SendGreetingAccepted === "enabled" && (
              <Grid item xs={12}>
                <Box className={classes.settingItem}>
                  <Typography className={classes.settingLabel}>
                    {i18n.t("settings.options.sendGreetingAcceptedMessageText")}
                  </Typography>
                  <Typography className={classes.settingDescription}>
                    {i18n.t("settings.options.sendGreetingAcceptedMessageTextDesc")}
                  </Typography>
                  <Box display="flex" flexDirection="column" gap={2} mt={2}>
                    <TextField
                      multiline
                      rows={4}
                      fullWidth
                      variant="outlined"
                      value={sendGreetingAcceptedMessageText}
                      onChange={(e) => {
                        const v = e.target.value;
                        if (v.length <= 500) setSendGreetingAcceptedMessageText(v);
                      }}
                      onBlur={(e) => {
                        const v = e.target.value;
                        const toSave =
                          String(v || "").trim() ||
                          DEFAULT_SEND_GREETING_ACCEPTED_MESSAGE_TEXT;
                        if (savedSendGreetingAcceptedMessageText !== toSave) {
                          persistSendGreetingAcceptedMessageText(v);
                        }
                      }}
                      placeholder={i18n.t(
                        "settings.options.sendGreetingAcceptedMessageTextPlaceholder"
                      )}
                      helperText={`${sendGreetingAcceptedMessageText.length}/500 ${i18n.t(
                        "settings.options.characters"
                      )}`}
                      disabled={
                        loadingSendGreetingAcceptedMessageText ||
                        loadingSendGreetingAccepted
                      }
                      InputProps={{ className: classes.textFieldInput }}
                    />
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() =>
                        persistSendGreetingAcceptedMessageText(
                          DEFAULT_SEND_GREETING_ACCEPTED_MESSAGE_TEXT
                        )
                      }
                      disabled={
                        loadingSendGreetingAcceptedMessageText ||
                        loadingSendGreetingAccepted
                      }
                      size="small"
                    >
                      {i18n.t("settings.options.restoreDefault")}
                    </Button>
                  </Box>
                </Box>
              </Grid>
            )}

            <Grid item xs={12} sm={6} md={4}>
              <SettingItem
                label={i18n.t("settings.options.sendTransferMessage")}
                description={i18n.t("settings.options.sendTransferMessageDesc")}
                value={SettingsTransfTicket}
                onChange={(e) => handleSettingsTransfTicket(e.target.value)}
                options={[
                  { value: "disabled", label: i18n.t("settings.states.disabled") },
                  { value: "enabled", label: i18n.t("settings.states.enabled") }
                ]}
                loading={loadingSettingsTransfTicket}
                classes={classes}
              />
            </Grid>

            {SettingsTransfTicket === "enabled" && (
              <Grid item xs={12}>
                <Box className={classes.settingItem}>
                  <Typography className={classes.settingLabel}>
                    {i18n.t("settings.options.transferTicketMessageText")}
                  </Typography>
                  <Typography className={classes.settingDescription}>
                    {i18n.t("settings.options.transferTicketMessageTextDesc")}
                  </Typography>
                  <Box display="flex" flexDirection="column" gap={2} mt={2}>
                    <TextField
                      multiline
                      rows={4}
                      fullWidth
                      variant="outlined"
                      value={transferTicketMessageText}
                      onChange={(e) => {
                        const v = e.target.value;
                        if (v.length <= 500) setTransferTicketMessageText(v);
                      }}
                      onBlur={(e) => {
                        const v = e.target.value;
                        const toSave =
                          String(v || "").trim() ||
                          DEFAULT_TRANSFER_TICKET_MESSAGE_TEXT;
                        if (savedTransferTicketMessageText !== toSave) {
                          persistTransferTicketMessageText(v);
                        }
                      }}
                      placeholder={i18n.t(
                        "settings.options.transferTicketMessageTextPlaceholder"
                      )}
                      helperText={`${transferTicketMessageText.length}/500 ${i18n.t(
                        "settings.options.characters"
                      )}`}
                      disabled={
                        loadingTransferTicketMessageText ||
                        loadingSettingsTransfTicket
                      }
                      InputProps={{ className: classes.textFieldInput }}
                    />
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() =>
                        persistTransferTicketMessageText(
                          DEFAULT_TRANSFER_TICKET_MESSAGE_TEXT
                        )
                      }
                      disabled={
                        loadingTransferTicketMessageText ||
                        loadingSettingsTransfTicket
                      }
                      size="small"
                    >
                      {i18n.t("settings.options.restoreDefault")}
                    </Button>
                  </Box>
                </Box>
              </Grid>
            )}

            <Grid item xs={12} sm={6} md={4}>
              <SettingItem
                label={i18n.t("settings.options.sendTicketCloseMessage")}
                description={i18n.t("settings.options.sendTicketCloseMessageDesc")}
                value={sendTicketCloseMessage}
                onChange={(e) => handleSendTicketCloseMessage(e.target.value)}
                options={[
                  { value: "disabled", label: i18n.t("settings.states.disabled") },
                  { value: "enabled", label: i18n.t("settings.states.enabled") }
                ]}
                loading={loadingSendTicketCloseMessage}
                classes={classes}
              />
            </Grid>

            {sendTicketCloseMessage === "enabled" && (
              <Grid item xs={12}>
                <Box className={classes.settingItem} style={{ marginTop: 16 }}>
                  <Typography className={classes.settingLabel}>
                    {i18n.t("settings.options.ticketCloseMessageText")}
                  </Typography>
                  <Typography className={classes.settingDescription}>
                    {i18n.t("settings.options.ticketCloseMessageTextDesc")}
                  </Typography>
                  <Box display="flex" flexDirection="column" gap={2} mt={2}>
                    <TextField
                      multiline
                      rows={4}
                      fullWidth
                      variant="outlined"
                      value={ticketCloseMessageText}
                      onChange={(e) => {
                        const v = e.target.value;
                        if (v.length <= 500) setTicketCloseMessageText(v);
                      }}
                      onBlur={(e) => {
                        const v = e.target.value;
                        const toSave =
                          String(v || "").trim() || DEFAULT_TICKET_CLOSE_MESSAGE;
                        if (savedTicketCloseMessageText !== toSave) {
                          persistTicketCloseMessageText(v);
                        }
                      }}
                      placeholder={i18n.t(
                        "settings.options.ticketCloseMessageTextPlaceholder"
                      )}
                      helperText={`${ticketCloseMessageText.length}/500 ${i18n.t(
                        "settings.options.characters"
                      )}`}
                      disabled={
                        loadingTicketCloseMessageText ||
                        loadingSendTicketCloseMessage
                      }
                      InputProps={{ className: classes.textFieldInput }}
                    />
                    <Box display="flex" gap={2} alignItems="center">
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={handleRestoreDefaultTicketCloseMessage}
                        disabled={
                          loadingTicketCloseMessageText ||
                          loadingSendTicketCloseMessage
                        }
                        size="small"
                      >
                        {i18n.t("settings.options.restoreDefault")}
                      </Button>
                      {loadingTicketCloseMessageText && (
                        <Typography variant="caption" color="textSecondary">
                          {i18n.t("settings.states.updating")}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Box>
              </Grid>
            )}

            <Grid item xs={12} sm={6} md={4}>
              <SettingItem
                label={i18n.t("settings.options.sendGreetingOneQueue")}
                description={i18n.t("settings.options.sendGreetingOneQueueDesc")}
                value={sendGreetingMessageOneQueues}
                onChange={(e) => handleSendGreetingMessageOneQueues(e.target.value)}
                options={[
                  { value: "disabled", label: i18n.t("settings.states.disabled") },
                  { value: "enabled", label: i18n.t("settings.states.enabled") }
                ]}
                loading={loadingSendGreetingMessageOneQueues}
                classes={classes}
              />
            </Grid>

            {sendGreetingMessageOneQueues === "enabled" && (
              <Grid item xs={12}>
                <Box className={classes.settingItem}>
                  <Typography className={classes.settingLabel}>
                    {i18n.t("settings.options.greetingOneQueueMessageText")}
                  </Typography>
                  <Typography className={classes.settingDescription}>
                    {i18n.t("settings.options.greetingOneQueueMessageTextDesc")}
                  </Typography>
                  <Box display="flex" flexDirection="column" gap={2} mt={2}>
                    <TextField
                      multiline
                      rows={4}
                      fullWidth
                      variant="outlined"
                      value={greetingOneQueueMessageText}
                      onChange={(e) => {
                        const v = e.target.value;
                        if (v.length <= 500) setGreetingOneQueueMessageText(v);
                      }}
                      onBlur={(e) => {
                        const v = e.target.value;
                        const toSave =
                          String(v || "").trim() ||
                          DEFAULT_SEND_GREETING_ONE_QUEUE_MESSAGE_TEXT;
                        if (savedGreetingOneQueueMessageText !== toSave) {
                          persistGreetingOneQueueMessageText(v);
                        }
                      }}
                      placeholder={i18n.t(
                        "settings.options.greetingOneQueueMessageTextPlaceholder"
                      )}
                      helperText={`${greetingOneQueueMessageText.length}/500 ${i18n.t(
                        "settings.options.characters"
                      )}`}
                      disabled={
                        loadingGreetingOneQueueMessageText ||
                        loadingSendGreetingMessageOneQueues
                      }
                      InputProps={{ className: classes.textFieldInput }}
                    />
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() =>
                        persistGreetingOneQueueMessageText(
                          DEFAULT_SEND_GREETING_ONE_QUEUE_MESSAGE_TEXT
                        )
                      }
                      disabled={
                        loadingGreetingOneQueueMessageText ||
                        loadingSendGreetingMessageOneQueues
                      }
                      size="small"
                    >
                      {i18n.t("settings.options.restoreDefault")}
                    </Button>
                  </Box>
                </Box>
              </Grid>
            )}

            <Grid item xs={12} sm={6} md={4}>
              <SettingItem
                label={i18n.t("settings.options.internalSignature")}
                description={i18n.t("settings.options.internalSignatureDesc")}
                value={internalSignature}
                onChange={(e) => handleInternalSignature(e.target.value)}
                options={[
                  { value: "disabled", label: i18n.t("settings.states.disabled") },
                  { value: "enabled", label: i18n.t("settings.states.enabled") }
                ]}
                loading={loadingInternalSignature}
                classes={classes}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <SettingItem
                label={i18n.t("settings.options.validateWhatsAppNumbers")}
                description={i18n.t("settings.options.validateWhatsAppNumbersDesc")}
                value={validateWhatsAppNumbers}
                onChange={(e) => handleValidateWhatsAppNumbers(e.target.value)}
                options={[
                  { value: "disabled", label: i18n.t("settings.states.disabled") },
                  { value: "enabled", label: i18n.t("settings.states.enabled") }
                ]}
                loading={loadingValidateWhatsAppNumbers}
                classes={classes}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* ZONA HORARIA PARA CAMPAÑAS - Fuera de subpestañas */}
      <OptionsTimezoneSection
        classes={classes}
        loadingTimezones={loadingTimezones}
        timezones={timezones}
        timezoneType={timezoneType}
        handleChangeTimezone={handleChangeTimezone}
        loadingTimezoneType={loadingTimezoneType}
      />

    </Box>
  );
}